import http from "./httpService";

const apiEndpoint = process.env.REACT_APP_API_PROSPECTSALESTOOL_URL + "/Bookmark";

export async function BookmarkSelection(request) {
  http.addBearerAuthorization();
  return await http.post(apiEndpoint + "/ValueCalculatorBookmark", request);
}
export async function GetBookmarkedPages(request) {
  http.addBearerAuthorization();
  return await http.post(apiEndpoint + `/GetBookmark?userId=${request.userId}`)
}
export async function DeleteBookmark(id) {
  http.addBearerAuthorization();
  return await http.delete(apiEndpoint + `/DeleteBookmark?id=${id}`)
}


export default {
  BookmarkSelection,
  GetBookmarkedPages,
  DeleteBookmark
}
